// extracted by mini-css-extract-plugin
export default {"w1090":"reset_w1090_oNBIo"};